import {
  BondRecordResponse,
  ShippingServiceResponse,
} from "../../components/forms/FormBondApp.types";
import { ServiceBase } from "../core";
import { ApiParams } from "../types";

// interface IShippingOptionsData {
//   record_access_key: string;
//   price: number;
//   shipping_method_id: string;
//   recipient_name: string;
//   street: string;
//   city: string;
//   state_code: string;
//   zip: string;
// }

interface IssuancesData {
  record_salesforce_id: string;
  record_access_key: string;
  transaction_id: string;
}

export type ShippingMethod = {
  created_at: string | null;
  id: string;
  name: string;
  price: number;
  updated_at: string | null;
};

export type ShippingMethodsResponse = {
  data: {
    methods: ShippingMethod[];
  };
};
class ShippingService extends ServiceBase {
  public static async getShippingMethods(queryRecordId: string | null, shippingStateCode: string | null = null) {
    const params = new URLSearchParams();
    if (queryRecordId) params.append('record_id', queryRecordId);
    if (shippingStateCode) params.append('shipping_state', shippingStateCode);

    const data: ApiParams = {
      method: "GET",
      url: `shipping-methods${params.toString() ? `?${params.toString()}` : ''}`
    };

    const response: ShippingMethodsResponse = await ServiceBase.callApi(data);
    return response;
  }

  public static async getShippingOption(
    recordId: string | null,
    accessKey: string | null
  ) {
    const data: ApiParams = {
      method: "GET",
      url: `bond-records/${recordId}/shipping?record_access_key=${accessKey}`,
    };

    const response: ShippingServiceResponse = await ServiceBase.callApi(data);

    return response;
  }

  public static async saveShippingOptions(
    recordId: string | null,
    shippingOptionsData: {
      zip: string;
      shipping_method_id: string;
      city: string;
      record_access_key: string | null;
      price: string;
      street: string;
      recipient_name: string;
      state_code: string;
    },
    id?: number
  ) {
    const data: ApiParams = {
      method: id ? "PUT" : "POST",
      url: `bond-records/${recordId}/shipping${id ? `/${id}` : ""}`,
      data: shippingOptionsData,
    };
    const response = await ServiceBase.callApi(data);

    return response;
  }

  public static async registerPayment(
    recordId: string | null,
    accessKey: string | null
  ) {
    const data: ApiParams = {
      method: "POST",
      url: `bond-records/${recordId}/payments?record_access_key=${accessKey}`,
      data: {
        payment_type: "bond_premium_salesforce_cc",
        ref_amount: 200,
        authorized_amount: 200,
        status_details: `Confirmation #${recordId}`,
      },
    };

    await ServiceBase.callApi(data);
  }
  public static async getIssuances(payload: IssuancesData) {
    const data: ApiParams = {
      method: "POST",
      url: `/issuances`,
      data: payload,
    };

    const response: BondRecordResponse = await ServiceBase.callApi(data);

    return response;
  }
}

export default ShippingService;
